import { useQuery } from '@tanstack/react-query';
import { searchUsers, DEFAULT_PER_PAGE } from '../services/IpAssistantService';
import { ipAssistantKeys } from './queryKeys';
export function useSearchUsers(query, page, sort) {
    return useQuery({
        queryKey: ipAssistantKeys.users(query, page, sort === null || sort === void 0 ? void 0 : sort.sortBy, sort === null || sort === void 0 ? void 0 : sort.sortDirection),
        queryFn: () => searchUsers(query, page, DEFAULT_PER_PAGE, sort),
        staleTime: 2 * 60 * 1000,
        retry: 3,
        keepPreviousData: true
    });
}
